module.exports = __webpack_public_path__ + "img/16.32d619d7.png";